module.exports = __webpack_public_path__ + "img/home-hero_en-3.d09788f.jpg";